import api from "./api";

// ================= FIELD VALUE ADDER PROFILES =================

// GET ALL
export const fetchFieldValueAdders = async () => {
  return (await api.get("/value-adder/profiles/")).data;
};

// GET ONE
export const getFieldValueAdder = async (id) => {
  return (await api.get(`/value-adder/profiles/${id}/`)).data;
};

// CREATE
export const createFieldValueAdder = async (payload) => {
  return (await api.post("/value-adder/profiles/", payload)).data;
};

// UPDATE
export const updateFieldValueAdder = async (id, payload) => {
  return (await api.put(`/value-adder/profiles/${id}/`, payload)).data;
};

// DELETE
export const deleteFieldValueAdder = async (id) => {
  return (await api.delete(`/value-adder/profiles/${id}/`)).data;
};